import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Image
} from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import ShareSuccessImg from '../../../assets/done-circle-icon.svg';

import Button from '../../Button';

function EditRequestModal(props) {
  const { isOpen, onSubmit, title, titleBtn, onClose, bgColorOverlay } = props;

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay backgroundColor={bgColorOverlay} />
      <ModalContent py={5} px={'15px'} w={'396px'} bgColor={'#FAFAFA'} rounded={'12px'}>
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">{title}</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              onClick={onSubmit}
              alt=""
            />
          </div>
        </ModalHeader>
        <ModalBody p={0}>
          <div className="flex flex-col items-center mt-6 mb-4">
            <img className="w-[48px] h-[48px]" src={ShareSuccessImg} alt="" />
            <p className="text-[18px] font-[600] mt-3 text-center">
              Your request has been successfully updated!
            </p>
          </div>
        </ModalBody>
        <ModalFooter w="100%" p="0">
          <Button onClick={onSubmit} className="w-full h-[42px]">
            {titleBtn}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default EditRequestModal;
